<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<mat-spinner *ngIf="loading"></mat-spinner>

<div class="integration-wrapper" *ngIf="!loading && integrationId">
    <div class="logo-container">
        <img height="48" src="../../../assets/sophos_central.png" alt="Sophos Central Logo">
    </div>
    
    <form [formGroup]="formGroup">
        <p>{{fDirections}}</p>

        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>
                    {{fCID}}<span *ngIf="this.formGroup.get('client_id').invalid" style="color: red">{{fCIDInvalid}}</span>
                </mat-label>
                <input matInput name="client_id" id="client_id" type="text" formControlName="client_id" placeholder="{{fCIDPHolder}}" maxlength="36">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{fSecret}}</mat-label>
                <input matInput name="client_secret" id="client_secret" type="password" formControlName="client_secret">
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{fTenant}}</mat-label>
                <mat-select [formControl]="formGroup.controls.tenant_id">
                    <mat-option *ngFor="let tenant of tenants" value="{{tenant.id}}">{{ tenant.name || tenant.id }}</mat-option>
                </mat-select>
            </mat-form-field>
            <button [disabled]="this.formGroup.get('client_id').invalid" type="button" (click)="getTenants()" mat-raised-button>{{fGetTenant}}</button>
        </div>

        <div class="section">
            <mat-radio-group [formControl]="formGroup.controls.lock_option" aria-label="Select what happens when a threat is received.">
                <div>
                    <mat-radio-button value="device_only">{{fLockA}}</mat-radio-button>
                </div>
                <div>
                    <mat-radio-button value="device_sets">{{fLockB}}</mat-radio-button>
                </div>
                <div>
                    <mat-radio-button value="all_devices">{{fLockC}}</mat-radio-button>
                </div>
            </mat-radio-group>
        </div>

        <div class="section">
            <mat-checkbox disabled [formControl]="formGroup.controls.admin_unlock" matTooltip="Coming Soon">{{fAdmin}}</mat-checkbox>
        </div>

        <button type="button" (click)="cancel()" mat-raised-button>{{fCancel}}</button>
        <button type="button" color="primary" (click)="save()" [disabled]="!formGroup.valid" mat-raised-button>{{fSave}}</button>

    </form>
</div>
